import { HttpErrorResponse } from '@angular/common/http';

import { Guest } from '@recruitee/http-types';
import { createActions, ngrxEvent } from '@recruitee/ngrx';

const namespace = 'viewboxGuest';

export const ViewboxGuestActions = createActions(namespace, {
  save: ngrxEvent<{ data: any }>(),
  saveSuccess: ngrxEvent<Guest>(),
  saveFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
